import type { TimeRangePickerProps } from 'antd'
import dayjs, { type Dayjs } from 'dayjs'
import isoWeek from 'dayjs/plugin/isoWeek.js'

dayjs.extend(isoWeek)

function getDayRange(startDaysAgo: number, endDaysAgo = 0): [Dayjs, Dayjs] {
  const today = dayjs()
  return [today.subtract(startDaysAgo, 'day').startOf('day'), today.subtract(endDaysAgo, 'day').endOf('day')]
}

// 使用回调在选取时计算；日期时间范围也应覆盖所选日期的完整起止时间。
export const RANGE_PRESETS = [
  { label: '今天', value: () => getDayRange(0) },
  { label: '昨天', value: () => getDayRange(1, 1) },
  { label: '近 3 天', value: () => getDayRange(2) },
  { label: '近 7 天', value: () => getDayRange(6) },
  { label: '近 30 天', value: () => getDayRange(29) },
  {
    label: '上周',
    value: (): [Dayjs, Dayjs] => {
      const lastWeek = dayjs().subtract(1, 'week')
      return [lastWeek.startOf('isoWeek'), lastWeek.endOf('isoWeek')]
    }
  },
  {
    label: '本周',
    value: (): [Dayjs, Dayjs] => {
      const today = dayjs()
      return [today.startOf('isoWeek'), today.endOf('isoWeek')]
    }
  },
  {
    label: '上月',
    value: (): [Dayjs, Dayjs] => {
      const lastMonth = dayjs().subtract(1, 'month')
      return [lastMonth.startOf('month'), lastMonth.endOf('month')]
    }
  },
  {
    label: '本月',
    value: (): [Dayjs, Dayjs] => {
      const today = dayjs()
      return [today.startOf('month'), today.endOf('month')]
    }
  }
] satisfies NonNullable<TimeRangePickerProps['presets']>

// 历史报表不允许选择未来日期，本周、本月在今天截止。
export const PAST_RANGE_PRESETS = RANGE_PRESETS.map(({ label, value }) => ({
  label,
  value: (): [Dayjs, Dayjs] => {
    const [start, end] = value()
    const today = dayjs().endOf('day')
    return [start, end.isAfter(today) ? today : end]
  }
})) satisfies NonNullable<TimeRangePickerProps['presets']>
